import React, { useEffect, useState } from 'react';
import { cameraService } from '../../../services/central-api/cameras';
import FilterDropdown from '../../Filter/components/FilterDropdown';
import { translate } from '../../../services/translate';
import { StyleProp, TextStyle } from 'react-native';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    zIndex: number;
    labelFontSize?: number;
    labelStyle?: StyleProp<TextStyle>;
    label?: string;
}

function CameraTagsDropdown({ value, setValue, zIndex, labelFontSize, labelStyle, label }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);

    async function getTags() {
        try {
            const tags = await cameraService.getCameraTagsSimplified();
            setItems(tags.map((tag) => {
                return {
                    value: tag.id,
                    label: tag.name
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getTags();
    }, []);

    return (
        <FilterDropdown
            label={translate(label ?? 'tags')}
            items={items}
            setValue={setValue}
            value={value}
            multiple={true}
            mode='BADGE'
            zIndex={zIndex}
            labelFontSize={labelFontSize}
            labelStyle={labelStyle}
        />
    );
}

export default CameraTagsDropdown;
